import Pusher from "pusher-js";
import { getCurrentSubdomain } from "utils/helpers";
import vars from "utils/vars";

const ENABLE_TLS = vars.secrets.pusher.enableTLS;
const TENANT = getCurrentSubdomain();
const PORT = Number(vars.secrets.pusher.port) || 6001;
const WS_HOST = vars.secrets.pusher.host;
const PUSHER_KEY = vars.secrets.pusher.key;
const PUSHER_CLUSTER = vars.secrets.pusher.cluster;

// When REACT_APP_PUSHER_HOST is set, connect to Laravel Reverb (local/staging self-hosted).
// When unset, fall back to Pusher Cloud via cluster (legacy production).
const PUSHER_CONFIGURATIONS = {
	cluster: PUSHER_CLUSTER || "mt1",
	forceTLS: ENABLE_TLS,
	encrypted: ENABLE_TLS,
	disableStats: true,
	enabledTransports: ["ws", "wss"],
	...(WS_HOST
		? {
				wsHost: WS_HOST,
				wsPort: PORT,
				wssPort: PORT,
			}
		: {}),
	authEndpoint: `${vars.app.protocol}://${vars.app.adminDomain}/broadcasting/auth`,
	auth: {
		headers: {
			Accept: vars.api.headers.accept,
			Tenant: TENANT,
			...(!!localStorage.getItem(vars.localStorage.fieldsName.token)
				? { Authorization: localStorage.getItem(vars.localStorage.fieldsName.token) }
				: {}),
		},
	},
};

// Verbose Pusher logging in development only; production builds strip
// console output via drop_console, but this keeps dev logs opt-in by env.
Pusher.logToConsole = process.env.NODE_ENV !== "production";
const pusher = PUSHER_KEY ? new Pusher(PUSHER_KEY, PUSHER_CONFIGURATIONS) : null;

if (!pusher) {
	console.error("❌ Pusher not initialized: Missing PUSHER_KEY in environment variables");
}

export default pusher;
